import { appUouBiMiddleware } from '../app/bi-events/init-middleware';
import { uouLikeClickEvent } from '../app/bi-events/uou-events/uou-like-click-event';
import { uouButtonClickedEvent } from '../app/bi-events/uou-events/uou-button-clicked-event';
import { uouDeletePostSuccessEvent } from '../app/bi-events/uou-events/uou-delete-post-success-event';
import { uouSetPostEditorPostEvent } from '../app/bi-events/uou-events/uou-set-post-editor-post-event';
import { uouPageOpenedEvent } from '../app/bi-events/uou-events/uou-page-opened-event';
import { uouTogglePinPostEvent } from '../app/bi-events/uou-events/uou-toggle-pin-post-event';
import { uouToggleCommentsEvent } from '../app/bi-events/uou-events/uou-toggle-comments-event';
import { uouEditCommentEvent } from '../app/bi-events/uou-events/uou-edit-comment-event';
import { uouDeleteCommentEvent } from '../app/bi-events/uou-events/uou-delete-comment-event';
import { uouClickProfileLinkEvent } from '../app/bi-events/uou-events/uou-click-profile-link-event';
import { uouDuplicatePostEvent } from '../app/bi-events/uou-events/uou-duplicate-post-event';
import { uouClickPostTitleEvent } from '../app/bi-events/uou-events/uou-click-post-title-event';
import { ORIGIN_BLOG_MEMBERS_AREA } from './constants/bi-origins';

export default function initUouBiMiddleware() {
  const eventMap = {
    ...uouLikeClickEvent,
    ...uouButtonClickedEvent,
    ...uouDeletePostSuccessEvent,
    ...uouSetPostEditorPostEvent,
    ...uouPageOpenedEvent,
    ...uouTogglePinPostEvent,
    ...uouToggleCommentsEvent,
    ...uouEditCommentEvent,
    ...uouClickProfileLinkEvent,
    ...uouDuplicatePostEvent,
    ...uouClickPostTitleEvent,
    ...uouDeleteCommentEvent,
  };

  return appUouBiMiddleware({
    eventMap,
    eventDefaults: {
      origin: ORIGIN_BLOG_MEMBERS_AREA,
    },
  });
}
